import { transport } from 'config/transport';

export function callApiUpdateCongDoanInfo(body) {
    return transport.put(`/congdoan`, body);
}
